module.exports = __webpack_public_path__ + "fonts/fontello.3ba9a24.ttf";